<template>
  <div class="sample-view panel-sections edge-to-edge">
    <component :is="typeComponent" :dv="dv" />
    <EntitySharing :dv="dv" :collapsed="!dv.isEditing" />
    <EntityOwnership :dv="dv" :collapsed="!dv.isEditing" />
  </div>
</template>

<script>
import { computed } from 'vue'
import GenericSample from './GenericSample.vue'
import SequencingLibrary from './sequencing/SequencingLibrary.vue'
import EMSample from './electron-microscopy/EMSample.vue'
import EntitySharing from '../shared/EntitySharing.vue'
import EntityOwnership from '../shared/EntityOwnership.vue'

// Dispatcher for sample detail views. Selects a type-specific component based
// on dv.modelType (e.g. SequencingLibrary, EMSample) and falls back to
// GenericSample for all other types. Each type component owns its own field
// layout and passes it to the shared SampleDescriptionGrid. EntitySharing and
// EntityOwnership are rendered outside the type component so they appear
// consistently for every sample type.
export default {
  name: 'SampleView',
  components: {
    EntitySharing,
    EntityOwnership,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const typeComponent = computed(() => {
      switch ((props.dv.modelType || '').toLowerCase()) {
        case 'sequencinglibrary':
          return SequencingLibrary
        case 'emsample':
          return EMSample
        default:
          return GenericSample
      }
    })

    return { typeComponent }
  },
}
</script>
